import { FaTh} from "react-icons/fa";
import { TbBuildingWarehouse } from "react-icons/tb";
import { DiAptana } from "react-icons/di";
import { MdOutlineShoppingCart, MdOutlineReportProblem } from "react-icons/md";

const menu = [
  {
    title: "Dashboard",
    icon: <FaTh />,
    path: "/dashboard",
  },
  {
    title: "Warehouse",
    icon: <TbBuildingWarehouse />,
    path: "/getproducts",
  },
    {
    title: "Faulty Items",
    icon: <MdOutlineReportProblem />,
    path: "/FaultyItemsPage",
  },
  {
    title: "Orders",
    icon: <MdOutlineShoppingCart />,
    childrens: [
      {
        title: "Orders Dashboard",
        path: "/orders",
      },
      {
        title: "Create Order",
        path: "/create-order",
      },
      {
        title: "Return Order",
        path: "/return-order",
      },
    ],
  },
  // {
  //   title: "Reports",
  //   icon: <TbReportSearch />,
  //   path: "/contact-us",
  // },
  {
    title: "System Maintenance",
    icon: <DiAptana />,
    permissions: ["admin", "editor"],
    childrens: [
      {
        title: "Users",
        path: "/user-maintenance",
        permissions: ["admin"] 

      },
      {
        title: "Products",
        path: "/product-maintenance",
        permissions: ["admin", "editor"]

      },
      {
        title: "Categories & Warehouses",
        path: "/categories-warehouses",
        permissions: ["admin"]

      },
      {
        title: "Alert Management",
        path: "/alert-management", 
        permissions: ["admin"]

      },
    ],
  },
];

export default menu;